import React from 'react'
import { Box, Typography } from '@mui/material'

// Local import
import OperationDays from 'module/leave/pages/adminLeaveSetting/components/OperationDays'
import LeavePolicy from 'module/leave/pages/adminLeaveSetting/components/LeavePolicy'
import LeaveCreditRequest from 'module/leave/pages/adminLeaveSetting/components/LeaveCreditRequest'
import LeaveCreditStatus from 'module/leave/pages/adminLeaveSetting/components/LeaveCreditStatus'
import LeaveImport from 'module/leave/pages/adminLeaveSetting/components/LeaveImport'
import LeaveDetailsImport from 'module/leave/pages/adminLeaveSetting/components/LeaveDetailsImport'

const AdminLeaveSetting = () => {
  return (
    <Box sx={{ boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box display={'flex'} flexDirection={'column'} sx={{ rowGap: 1 }} className="Operation Days">
        <Box>
          <Typography variant="h4" fontWeight="bold">
            Operation Days
          </Typography>
          <Typography variant="subtitle1" color="light-gray-text.main">
            Set operation days for your organization (eg. Work Day, Off/Rest Day, Holidays, Special
            Occasions, etc)
          </Typography>
        </Box>
        <OperationDays />
      </Box>

      <Box
        display={'flex'}
        flexDirection={'column'}
        sx={{ boxSizing: 'border-box', rowGap: 1 }}
        className="Leave Credit Request Policy"
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent={'space-between'}
        >
          <Box display={'flex'} flexDirection={'column'} sx={{ rowGap: 1 }}>
            <Box>
              <Typography variant="h4" fontWeight="bold">
                Leave Credit Request Policy
              </Typography>
              <Typography variant="subtitle1" color="light-gray-text.main">
                By enabling this, employees are able to request for leave credit
              </Typography>
            </Box>
          </Box>
          <LeaveCreditStatus />
        </Box>

        <LeaveCreditRequest />
      </Box>

      <Box
        display={'flex'}
        flexDirection={'column'}
        sx={{ boxSizing: 'border-box', rowGap: 1 }}
        className="Leave Policy"
      >
        <Box>
          <Typography variant="h4" fontWeight="bold">
            Leave Policy
          </Typography>
          <Typography variant="subtitle1" color="light-gray-text.main">
            Create and manage leave policy. Once enabled, the policy will automatically be applied
            to employees
          </Typography>
        </Box>
        <LeavePolicy />
      </Box>

      <Box
        display={'flex'}
        flexDirection={'column'}
        sx={{ boxSizing: 'border-box', rowGap: 1 }}
        className="Import External Data"
      >
        <Box>
          <Typography variant="h4" fontWeight="bold">
            Import External Data
          </Typography>
          <Typography variant="subtitle1" color="light-gray-text.main">
            Import large amount of employee data with an excel file.
          </Typography>
        </Box>
        <LeaveImport />
        <LeaveDetailsImport />
      </Box>
    </Box>
  )
}

export default AdminLeaveSetting
